import { Grid } from '@mui/material';
import { FC } from 'react';
import { useVat } from 'src/hooks/turnover/useVat';
import { calculateGrossMarginPercent } from 'src/utils/gross-margin/calculateGrossMargin';
import { numberWithSpaces } from 'src/utils/numberWithSpaces';
import { StyledDetailedKPICard } from '../../Turnover/TurnoverKpis';
import { calculateSummary } from '../calculateSummary';
import { SummaryReportProps } from '../types';

export const TotalSummaryTab: FC<SummaryReportProps> = ({ salesCampaignRows }) => {
    const vat = useVat();

    const summaryData = calculateSummary(salesCampaignRows);

    //! FIXME: Are GM% calculations correct? We cannot verify due to missing recommended retail prices in the data. The missing data causes wrong calculations, so for now we exclude them.
    const expectedGMPercent = calculateGrossMarginPercent(
        summaryData.totalSalesPriceOnSale,
        summaryData.totalCogsOnSale,
        vat
    );

    const expectedTotalGMPercent = calculateGrossMarginPercent(summaryData.totalSalesPrice, summaryData.totalCogs, vat);

    return (
        <Grid
            container
            spacing={2}
            sx={{
                alignItems: 'stretch',
            }}
        >
            <Grid
                size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 3,
                    xl: 12 / 7,
                }}
            >
                <StyledDetailedKPICard
                    title="Total stock value"
                    value={summaryData.totalStockValue}
                    valueFormatter={numberWithSpaces}
                    sx={{ flexGrow: 1, flexBasis: 0, overflow: 'hidden' }}
                />
            </Grid>
            <Grid
                size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 3,
                    xl: 12 / 7,
                }}
            >
                <StyledDetailedKPICard
                    title="Total stock value on sale"
                    value={summaryData.totalStockValueOnSale}
                    valueFormatter={numberWithSpaces}
                    sx={{ flexGrow: 1, flexBasis: 0, overflow: 'hidden' }}
                />
            </Grid>
            <Grid
                size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 3,
                    xl: 12 / 7,
                }}
            >
                <StyledDetailedKPICard
                    title="% stock value on sale"
                    value={summaryData.percentageStockValueOnSale}
                    valueFormatter={(value) => numberWithSpaces(value, { postfix: '%' })}
                    sx={{ flexGrow: 1, flexBasis: 0, overflow: 'hidden' }}
                />
            </Grid>
            <Grid
                size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 3,
                    xl: 12 / 7,
                }}
            >
                <StyledDetailedKPICard
                    title="Total expected sales iV"
                    value={summaryData.totalExpectedSalesIv}
                    valueFormatter={numberWithSpaces}
                    sx={{ flexGrow: 1, flexBasis: 0, overflow: 'hidden' }}
                />
            </Grid>
            <Grid
                size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 3,
                    xl: 12 / 7,
                }}
            >
                <StyledDetailedKPICard
                    title="Avg. markdown %"
                    value={summaryData.avgMarkDown}
                    valueFormatter={(value) => numberWithSpaces(value, { postfix: '%', default: 'N/A' })}
                    sx={{ flexGrow: 1, flexBasis: 0, overflow: 'hidden' }}
                />
            </Grid>
            <Grid
                size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 3,
                    xl: 12 / 7,
                }}
            >
                <StyledDetailedKPICard
                    title="Expected GM%"
                    value={expectedGMPercent}
                    valueFormatter={(value) => numberWithSpaces(value, { postfix: '%', default: 'N/A' })}
                    sx={{ flexGrow: 1, flexBasis: 0, overflow: 'hidden' }}
                />
            </Grid>
            <Grid
                size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 3,
                    xl: 12 / 7,
                }}
            >
                <StyledDetailedKPICard
                    title="Expected total GM%"
                    value={expectedTotalGMPercent}
                    valueFormatter={(value) => numberWithSpaces(value, { postfix: '%', default: 'N/A' })}
                    sx={{ flexGrow: 1, flexBasis: 0, overflow: 'hidden' }}
                />
            </Grid>
        </Grid>
    );
};
